import React from "react";

const breadcrumbConfig = [
    {
        path: "/dashboard",
        breadcrumb: "Home",
    },
    {
        path: "/admin/dashboard",
        breadcrumb: "Home",
    },
    {
        path: "/admin/plans",
        breadcrumb: "Plans",
        parent: "/admin/dashboard",
    },
    {
        path: "/admin/users",
        breadcrumb: "Users",
        parent: "/admin/dashboard",
    },
    {
        path: "/admin/infrastructure-manager",
        breadcrumb: "Infrastructure",
        parent: "/admin/dashboard",
    },
    {
        path: "/admin/compute-types",
        breadcrumb: "Compute Types",
        parent: "/admin/dashboard",
    },
    {
        path: "/admin/plan-categories",
        breadcrumb: "Plan Categories",
        parent: "/admin/dashboard",
    },
    {
        path: "/admin/users/:id",
        breadcrumb: ({ match }) => `User ${match.params.id}`,
        parent: "/admin/users",
    },
];

export default breadcrumbConfig;
